import React, { useEffect, useState } from "react";
import { orendaUserManager } from "./orendaUserManager";

// Cognito redirects here after a hosted-UI logout. If we opened logout in a
// popup, finish the popup callback so the opener knows. Otherwise just show
// a signed-out message.
const OrendaLogout = () => {
  const [error, setError] = useState(null);

  useEffect(() => {
    const isPopup = window.opener && window.opener !== window;
    if (isPopup) {
      orendaUserManager
        .signoutPopupCallback()
        .catch((err) => setError(err.message || String(err)));
    } else {
      // Belt & braces — clear any lingering user in this window too.
      orendaUserManager.removeUser().catch(() => {});
    }
  }, []);

  return (
    <div style={{ padding: 40 }}>
      {error ? (
        <div style={{ color: "#dc3545" }}>
          <strong>Logout callback error:</strong> {error}
        </div>
      ) : (
        <div>You have been signed out.</div>
      )}
    </div>
  );
};

export default OrendaLogout;
